


























import { namespace } from 'vuex-class';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { CART } from '@/store/types';
import { Fair } from '@/services/fair/Fair';
import { FairOrderDetailService } from '@/services/order/FairOrderDetailService';
import { DateRange } from '@/services/util/DateRange';
import DatePickerVue from '@/common/DatePickerVue.vue';

const cart = namespace(CART);

@Component({
  components: {
    DatePickerVue
  }
})
export default class RequestedDeliveryDateRow extends Vue {

  get validDateRange(): DateRange {
    return {
      rangeStart: this.firstPossibleDeliveryDate,
      rangeEnd: this.fair.lastPossibleDeliveryDate
    };
  }

  get firstPossibleDeliveryDate(): (Date | null) {
    if (!this.fair.firstPossibleDeliveryDate) {
      return null;
    }

    const now = new Date();

    if (this.fair.firstPossibleDeliveryDate < now) {
      return now;
    }

    return this.fair.firstPossibleDeliveryDate;
  }

  @Prop({required: false, default: 'de'})
  public locale: string;
  @Prop()
  public fair: Fair;

  public requestedDeliveryDay?: Date = null;
  public requestedDeliveryDayFresh?: Date = null;

  private fairOrderDetailService = FairOrderDetailService.singleton();

  @Watch('requestedDeliveryDay')
  public onDeliveryDayChange() {
    this.fairOrderDetailService.saveRequestedDeliveryDay(this.requestedDeliveryDay);
  }

  @Watch('requestedDeliveryDayFresh')
  public onFreshDeliveryDayChange() {
    this.fairOrderDetailService.saveRequestedDeliveryDayFreshProducts(this.requestedDeliveryDayFresh);
  }
}
